// extracted by mini-css-extract-plugin
export default {"wrapper":"Nav_wrapper__DE9gG","active":"Nav_active__agu0E","onlyMobile":"Nav_onlyMobile__yB29j","onlyDesktop":"Nav_onlyDesktop__XAu5l"};